import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  value: {
    userList: [],
    loaded: false
  }
};
const userListSlice = createSlice({
  name: "userListInfo",
  initialState,
  reducers: {
    getUserList: (state, action) => {
      state.value = {
        userList: action.payload,
        loaded: true
      };
    },
    updateUserList: (state, action) => {
      let usr = action.payload;
      console.log(usr);
      let userList = [...state.value.userList];
      let eUsr = userList.find((u) => u.userId === usr.userId);
      if (eUsr) {
        let idx = userList.indexOf(eUsr);
        let nUsr = { ...eUsr };
        nUsr.userName = usr.userName;
        nUsr.isActive = usr.isActive;
        nUsr.licenseLevel = usr.licenseLevel;
        nUsr.trinFormsLicenseLevel = usr.trinFormsLicenseLevel;
        console.log(nUsr);
        userList.splice(idx, 1, nUsr);
        state.value = {
          userList,
          loaded: true
        };
      } else {
        console.log("user needs to be added");
        let nUser = {
          userId: parseInt(usr.userId, 10),
          userName: usr.userName,
          isActive: usr.isActive,
          licenseLevel: usr.licenseLevel,
          trinFormsLicenseLevel: usr.trinFormsLicenseLevel
        };
        userList.push(nUser);
        console.log(userList);
        state.value = {
          userList,
          loaded: true
        };
      }
    }
  }
});
export const { getUserList, updateUserList } = userListSlice.actions;
export default userListSlice.reducer;
